/**
 * US-65: модалка «Профиль».
 *
 * Read-only показ карточки пользователя — ФИО, login, email, роли.
 * Редактирование данных профиля (full_name, email и пр.) — это про
 * admin/HR-impersonation, через /admin/, а не self-service. Пока
 * только просмотр.
 */

import { Modal, Stack, Text, Group, Badge, Divider } from "@mantine/core";

import type { Me } from "../api/client";
import { DelegationSettings } from "./DelegationSettings";

interface Props {
  opened: boolean;
  onClose: () => void;
  me: Me;
}

const ROLE_LABELS: Record<string, string> = {
  employee: "Сотрудник",
  line_manager: "Линейный руководитель",
  project_manager: "Руководитель проекта",
  hr: "HR",
  project_office_head: "РПО",
  admin: "Администратор",
};

export function ProfileModal({ opened, onClose, me }: Props) {
  const roles = me.roles ?? [];

  return (
    <Modal opened={opened} onClose={onClose} title="Профиль" centered size="md">
      <Stack gap="md">
        <div>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            ФИО
          </Text>
          <Text fw={500}>{me.full_name || "—"}</Text>
        </div>
        <div>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            Логин
          </Text>
          <Text fw={500} ff="monospace">
            {me.username}
          </Text>
        </div>
        <div>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            Email
          </Text>
          <Text fw={500}>{me.email || "—"}</Text>
        </div>
        {roles.length > 0 && (
          <div>
            <Text size="xs" c="dimmed" tt="uppercase" fw={600} mb={6}>
              Роли
            </Text>
            <Group gap={6}>
              {roles.map((r) => (
                <Badge key={r} variant="light" color="indigo">
                  {ROLE_LABELS[r] ?? r}
                </Badge>
              ))}
            </Group>
          </div>
        )}
        <Text size="xs" c="dimmed">
          Чтобы изменить данные профиля (ФИО, email, роли) — обратитесь к администратору SKEDD.
        </Text>
        {(me.is_line_manager || me.is_project_manager) && (
          <>
            <Divider />
            <DelegationSettings />
          </>
        )}
      </Stack>
    </Modal>
  );
}
